import { EmployeeLevelEnum, Change, NationalContractLevelEnum } from '../../../types'

export const EMPTY_CHANGE: ContractChangeWithObjectPayload = {
  id: undefined,
  validFrom: undefined,
  changes: {
    employeeLevel: undefined,
    governmentJobTitle: undefined,
    salary: undefined,
    bonus: undefined,
  },
}

export interface ContractChangeWithObjectPayload {
  id?: number
  validFrom?: string
  changes: ContractChangePayload
}

export interface ContractChangePayload {
  employeeLevel?: EmployeeLevelEnum
  salary?: number
  bonus?: number
  nationalReferenceLevel?: NationalContractLevelEnum
  governmentJobTitle?: string
}

export const transformToContractChangeObject = (change: Pick<Change, 'id' | 'validFrom' | 'changes'>): ContractChangeWithObjectPayload => {
  const result: ContractChangeWithObjectPayload = {
    id: change.id ? change.id : undefined,
    changes: change.changes ? JSON.parse(change.changes) : {},
    validFrom: change.validFrom,
  }
  return result
}
